"use strict";

exports.__esModule = true;
exports.getThemeBrandProp = exports.getColor = exports.rgba = void 0;

var _colors = _interopRequireDefault(require("../configs/colors"));

var _is = require("../../utilities/is");

var _get = _interopRequireDefault(require("../../utilities/get"));

var _color = require("../../utilities/color");

exports.rgba = _color.rgba;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Retrieves a color/shade from the Color palette
 * @param   {number | string} args The color arguments.
 * @returns {string} The fetched color HEX code.
 */


var getColor = function getColor() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var path = args.map(function (arg) {
    return (0, _is.isNumber)(arg) ? arg.toString() : arg;
  });
  var defaultColor = 'currentColor';
  var firstArg = path[0]; // Defaults to Blue "500"

  if (path.length === 0) {
    return defaultColor;
  } // Dot notation


  if (firstArg.indexOf('.') >= 0) {
    path = firstArg.split('.');
  } // Default to shade "default"


  if (path.length === 1) {
    path.push('default');
  }

  var index = 0;
  var color = _colors.default;

  while (color != null && index < path.length) {
    color = color[path[index++]];
  }

  if ((0, _is.isObject)(color)) {
    color = color['default'];
  }

  return color || defaultColor;
};
/**
 * Retrieves a brand property from ThemeProvider.
 * @param   {Object} props The styled props.
 * @param   {string} path  The props path to retrieve
 * @param   {any} fallback The fallback prop.
 * @returns {any} The fetched property
 */


exports.getColor = getColor;

var getThemeBrandProp = function getThemeBrandProp(props, path, fallback) {
  if (props === void 0) {
    props = {};
  }

  if (path === void 0) {
    path = '';
  }

  if (fallback === void 0) {
    fallback = '';
  }

  return (0, _get.default)(props, "theme.brandColor." + path, fallback);
};

exports.getThemeBrandProp = getThemeBrandProp;